import { Controller } from "@hotwired/stimulus"

// Auto-submit parent form on change (sheet role selects, etc.).
// After Turbo Stream replace, re-assert the selected value from data-sheet-role-current
// so the visible option always matches the server (table-row stream bugs left stale selects).
export default class extends Controller {
  connect() {
    this.syncSelectFromDataset()
  }

  debouncedSubmit(event) {
    clearTimeout(this._saveTimer)
    this._saveTimer = setTimeout(() => this.submit(event), 450)
  }

  submit(event) {
    if (event?.type === "keydown") {
      if (event.isComposing || event.repeat || !["Enter", "Tab"].includes(event.key)) return
      // Let Tab and Shift+Tab retain their normal focus navigation.
      if (event.key === "Enter") event.preventDefault()
    }
    clearTimeout(this._saveTimer)

    const el = event?.target || this.element
    const form = this.resolveForm(el)
    if (!form) return

    // Optimistic: keep the user's choice visible while the request is in flight.
    if (el && el.tagName === "SELECT" && el.dataset.sheetRoleCurrent !== undefined) {
      el.dataset.sheetRoleCurrent = el.value
      el.className = el.className
        .replace(/cd-role-select--\w+/g, "")
        .trim()
      el.classList.add("cd-role-select", `cd-role-select--${el.value}`)
    }

    this.submitForm(form)
  }

  resolveForm(el) {
    const direct = el?.form
    if (direct && direct.tagName === "FORM") return direct

    const formId = el?.getAttribute?.("form") || this.element.getAttribute?.("form")
    if (formId) {
      const byId = document.getElementById(formId)
      if (byId && byId.tagName === "FORM") return byId
    }

    const closest = this.element.closest?.("form")
    if (closest && closest.tagName === "FORM") return closest

    return null
  }

  submitForm(form) {
    const proto = window.HTMLFormElement?.prototype
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit()
      return
    }
    if (proto && typeof proto.requestSubmit === "function") {
      proto.requestSubmit.call(form)
      return
    }
    if (proto && typeof proto.submit === "function") {
      proto.submit.call(form)
    }
  }

  syncSelectFromDataset() {
    const el = this.element
    if (!el || el.tagName !== "SELECT") return
    const expected = el.dataset.sheetRoleCurrent
    if (expected == null || expected === "") return
    if (el.value !== expected) {
      el.value = expected
    }
    // Keep role color class in sync with the selected value.
    el.className = el.className.replace(/cd-role-select--\w+/g, "").trim()
    el.classList.add("cd-role-select", `cd-role-select--${expected}`)
  }
}
